import { createSlice } from '@reduxjs/toolkit';
import {
  getManageMention,
  submitReportReason,
  updateManageMention,
} from 'redux/services/SettingsService';

export const SettingsSlice = createSlice({
  name: 'settings',
  initialState: {},
  reducers: {},
});

export const handleGetManageMention = () => async () => {
  return getManageMention();
};

export const handleUpdateManageMention = (payload) => async () => {
  return updateManageMention(payload);
};

export const handleSubmitReportReason = (payload) => async () => {
  return submitReportReason(payload);
};

// export const {} = SettingsSlice.actions;
export default SettingsSlice.reducer;
